import { Request } from '~src/httpClient/serverApi/requests/Request';

/**
 * Parameters for the VizPortal `deletePlan` Web Client method
 * (WebClientContentMobilityAppService.deletePlan). Deletes a single plan by LUID.
 */
export interface IDeleteContentRelayPlanParams {
  luid: string;
}

export interface IDeleteContentRelayPlanResult {
  deleted?: boolean;
}

export class DeleteContentRelayPlanRequest extends Request<IDeleteContentRelayPlanParams, IDeleteContentRelayPlanResult> {
  constructor(params: IDeleteContentRelayPlanParams) {
    super('deletePlan', params);
  }
}
